import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { SpecialOfferItem } from "./SpecialOfferItem";
export var LeagueRewardSpecialOfferItems = React.memo(function (_a) {
    var currentGiftItems = _a.currentGiftItems;
    var renderedItems = currentGiftItems.map(function (element, index) {
        return element.resource ? (React.createElement(SpecialOfferItem, { item: element, key: "" + element.resource.locaKey + index })) : (React.createElement(React.Fragment, null));
    });
    return (React.createElement(ScrollBar, { className: "dialog-league-reward-special-offer__scrollable-content" },
        React.createElement("div", { className: "flex flex--guts flex--stacked" }, renderedItems)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueRewardSpecialOfferItems.tsx
// module id = 2951
// module chunks = 3